import { render, staticRenderFns } from "./signupSuccess.vue?vue&type=template&id=2b24b838&scoped=true&"
import script from "./signupSuccess.vue?vue&type=script&lang=js&"
export * from "./signupSuccess.vue?vue&type=script&lang=js&"
import style0 from "./signupSuccess.vue?vue&type=style&index=0&id=2b24b838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24b838",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VImg,VLayout,VProgressCircular,VRow})
